import { categoryOf, difficultyOf, type Category } from '@shared/minigames';
import type { CardData } from '@shared/types';
import { gameInfo } from './info';
import { HoldToPeek } from './kit';
import { TurnGame, type TurnGameConfig } from './TurnGame';

const CATEGORY: Record<Category, { label: string; gesture: string }> = {
  film: { label: '🎬 Film', gesture: 'Crank an old camera' },
  song: { label: '🎵 Song', gesture: 'Pretend to sing' },
  tv: { label: '📺 TV show', gesture: 'Draw a box in the air' },
};

function CharadesCard({ card }: { card: CardData }) {
  const cat = categoryOf(card);
  const words = card.text.split(/\s+/).length;
  return (
    <div className="stack" style={{ gap: 10 }}>
      <div className="row" style={{ justifyContent: 'center' }}>
        {cat && <span className="chip blue">{CATEGORY[cat].label}</span>}
        <span className="chip">
          {words} {words === 1 ? 'word' : 'words'}
        </span>
        {cat && <span className="muted small">Sign: {CATEGORY[cat].gesture.toLowerCase()}</span>}
      </div>
      <HoldToPeek>
        <div className={`mg-card charades ${difficultyOf(card)}`}>
          <span className="mg-big">{card.text}</span>
          {card.gloss && <span className="mg-gloss">{card.gloss}</span>}
          {card.explanation && <span className="mg-explain">{card.explanation}</span>}
          <span className={`chip mg-diff ${difficultyOf(card)}`}>{difficultyOf(card)}</span>
        </div>
      </HoldToPeek>
    </div>
  );
}

const config: TurnGameConfig = {
  game: 'charades',
  info: gameInfo('charades'),
  defaults: { teams: ['', ''], difficulties: ['easy', 'medium'], categories: ['film', 'song', 'tv'], turnSeconds: 90, turnsPerTeam: 3 },
  timerOptions: [60, 90, 120],
  filters: ['category', 'difficulty'],
  fouls: false,
  renderCard: (card) => <CharadesCard card={card} />,
  readyHint: (team) => `Pick an actor from ${team}. Only the actor looks at the phone. Everyone else in ${team} guesses.`,
};

export function Charades() {
  return <TurnGame config={config} />;
}
